module.exports = __webpack_public_path__ + "static/media/privacy-policy.5c2232bb.pdf";